import { render, staticRenderFns } from "./Adminu.vue?vue&type=template&id=f80db7b2&"
import script from "./Adminu.vue?vue&type=script&lang=js&"
export * from "./Adminu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports